function LegalLinks() {
  return (
    <footer className="legal-links">
      <nav aria-label="Legal">
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms of use</a>
      </nav>
    </footer>
  );
}

export default LegalLinks;
